<template>
  <button
    v-tooltip.bottom="tooltipText"
    class="flex size-6 items-center justify-center rounded border p-1 transition hover:border-gray-200 hover:bg-gray-200"
    @click="$emit('click')"
  >
    <span class="sr-only">{{
      openState === "open" ? t("collapse") : t("expand")
    }}</span>
    <span class="relative flex flex-col gap-[0.1875rem]">
      <i-icon-park-right
        class="absolute -right-0.5 -top-[0.1875rem] h-2.5 w-2.5 transition-transform"
        :class="{
          'rotate-90': openState === 'open',
          '-rotate-90': openState === 'closed',
          'rotate-0': openState === 'mixed',
        }"
      />
      <span class="block h-px w-1.5 bg-black"></span>
      <span class="block h-px w-1.5 bg-black"></span>
      <span class="block h-px w-3.5 bg-black"></span>
      <span class="block h-px w-3.5 bg-black"></span>
    </span>
  </button>
</template>

<script setup lang="ts">
import type { OpenState } from "~/composables/useLegalTextDisclosure";
const { t } = useI18n();
const { openState } = defineProps<{
  openState: OpenState;
}>();

defineEmits<{
  (e: "click"): void;
}>();

const tooltipText = computed(() =>
  openState === "open" ? t("collapse") : t("expand")
);
</script>

<i18n>
  {
    "de": {
      "collapse": "Alle Überschriften einklappen",
      "expand": "Alle Überschriften ausklappen"
    },
    "en": {
      "collapse": "Collapse all headings",
      "expand": "Expand all headings"
    }
  }
</i18n>
